import { CapoPlugin } from "/opt/buildhome/repo/frontend/node_modules/@unhead/vue/dist/index.mjs";
export default import.meta.server ? [CapoPlugin({ track: true })] : [];